import {
  ajaxSetup,
  ajax,
  getJSON
} from 'jquery'
import {
  IOptions
} from "../options";
import {
  getConfig
} from '../components/Utils'

import MetaJSON from '../MetaJSON'

export interface IHandler {
  (...params: any[]): void;
}

export interface IErrorHandler {
  (status: number, error: string): void;
}

export interface IProgressHandler {
  (progress: number): void;
}

export interface IHandlers {
  before ? : IHandler;
  success ? : IHandler;
  anyway ? : IHandler;
  error ? : IErrorHandler;
  progress ? : IProgressHandler;
}

export interface IFileOptions {
  id: string;
  field: string;
  maxSize: number;
  format: string;
  element: HTMLInputElement;
}

interface RequestOptions {
  url: string;
  method: string;
  contentType ? : string | boolean;
  xhr ? : () => XMLHttpRequest;
  processData ? : boolean;
  data ? : any;
}

export function createApiClient(form_type: string = null, process_id:number = 0) {
  let formates = {
    "PDF": ["PDF"],
    "Image": ["JPG", "PNG", "JPEG"]
  };

  ajaxSetup({
    xhrFields: {
      withCredentials: true
    }
  })

  let config = getConfig();
  if (form_type !== null) {
    config.form_type = form_type
  }
  if (process_id !== null) {
    config.process_id = process_id
  }
  // config.filesUrl = `${config.filesUrl}/${config.id}/${config.valuesId}`;

  // return new ApiClient(config, formates, false)

  return new ApiClient(config, formates, false);
}

const errorHandler = (_, response) => {
  const {
    errors
  } = JSON.parse(response);
  console.log('errors:', errors, ' response:', response);
  if (errors.length > 0) {
    if (errors[0].error.code === '400') {
      alert(errors[0].error.message);
      window.location.reload();
    }
  }
};

export class ApiClient {

  private lock: boolean;
  private options: IOptions;
  private setValueUrl: string;
  private urlApi: string;
  private userApi: string;
  private companiesApi: string;
  private actionUrl: string;
  private filesUrl: string;

  public readonly FileFormats: {
    [format: string]: Array < string >
  };

  constructor(options: IOptions, formats: {
    [format: string]: Array < string >
  }, lock: boolean) {
    this.options = options;
    this.setValueUrl = this.options.apiUrl + "/item/" +  "/"+ this.options.process_id + "/";
    this.actionUrl = this.options.apiUrl + "/action/" + this.options.process_id + "/";
    this.urlApi = this.options.apiUrl;
    this.userApi = this.options.apiUrl;
    this.companiesApi = this.options.apiUrl;
    this.filesUrl = this.options.apiUrl + '/requests/';

    this.FileFormats = formats;

    this.lock = lock;
    this.getFileUrl = this.getFileUrl.bind(this);
    this.setFileValue = this.setFileValue.bind(this);
    this.deleteFileValue = this.deleteFileValue.bind(this);
  }

  public isLocked() {
    return this.lock;
  };

  public me(handlers: IHandlers) {
    getJSON(`${this.urlApi}/users/me/`, handlers.success);
  }

  public getTypes(handlers: IHandlers) {
    getJSON(`${this.urlApi}/requests/type/`, handlers.success);
  }

  public getCompany(orn: string, handlers: IHandlers) {
    this.send({
      url: `${this.urlApi}/users/me/set_company/${orn}/`,
      method: 'POST',
      contentType: "application/json",
    }, handlers);
  }

  public getCompanies(handlers: IHandlers) {
    this.send({
      url: `${this.urlApi}/users/me/list_company/`,
      method: 'GET',
      contentType: 'application/json'
    }, handlers);
  }

  public createRequest(slug: string, orn: string, handlers: IHandlers) {
    this.send({
      url: `${this.urlApi}/requests/create/${orn}/${slug}/`,
      method: 'POST'
    }, handlers)
  }

  public getRequests(orn: string, handlers: IHandlers) {
    this.send({
      url: `${this.urlApi}/requests/list/${orn}/`,
      method: 'GET'
    }, handlers);
  }

  public getRequest(id: string, handlers: IHandlers) {
    this.send({
      url: `${this.urlApi}/requests/${id}/`,
      method: 'GET'
    }, handlers);
  }

  public saveRequest(id: string, data: any, handlers: IHandlers) {
    fetch(`${this.urlApi}/requests/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ data: data })
    }).then(response => handlers.success(response));
  }

  public deleteRequest(id: string, handlers: IHandlers) {
    fetch(`${this.urlApi}/requests/${id}`, {
      method: 'DELETE',
    }).then(response => handlers.success(response));
  }

  public sendDocument(id: string, data: any, handlers: IHandlers) {
    this.send({
      url: `${this.urlApi}/requests/${id}`,
      method: "POST",
      contentType: "application/json",
      data: JSON.stringify({ data: data })
    }, handlers);
  }

  public getReportUrl(formId: string, valuesId: string) {
    return `${this.userApi}/report/${formId}/${valuesId}`;
  }

  public getAttachFileUrl(formId: string, valuesId: number, uid: string) {
    return `${this.options.apiUrl}/${formId}/${valuesId}/notify/${uid}/files`;
  }

  public createSession(formId: string, company: Object, handlers: IHandlers) {
    this.send({
      url: `${this.urlApi}/${formId}`,
      method: 'POST',
      contentType: "application/json",
      data: JSON.stringify(company)
    }, handlers);
  }



  public getNotify(formId: string, values: number, handlers: IHandlers) {
    getJSON(`${this.urlApi}/notify/${formId}/${values}`, handlers.success);
  }

  public getHistory(form: string, values: number, handlers: IHandlers) {
    getJSON(`${this.userApi}/history/${form}/${values}`, handlers.success);
  }

  public company(handlers: IHandlers) {
    getJSON(`${this.userApi}/company/`, handlers.success);
  }

  public getCompanyORN(inn: string, handlers: IHandlers) {
    getJSON(`${this.userApi}/company/orn/${inn}`, handlers.success)
      .fail(handlers.error);
  }

  public getProjects(orn: string, handlers: IHandlers) {
    getJSON(`${this.userApi}/users/me/company_projects/${orn}/`, handlers.success)
      .fail(handlers.error);
  }

  public redirect(url: string) {
    window.location.href = `${this.userApi}/auth?url=${encodeURIComponent(window.location.href)}`;
  }

  public singout(url: string) {
    window.location.href = `${this.userApi}/singout?url=${encodeURIComponent(window.location.href)}`;
  }

  public sendValues(handlers: IHandlers) {
    this.send({
      url: this.actionUrl + "/send",
      method: "POST"
    }, handlers);
  }

  public sendRevoke(handlers: IHandlers) {
    this.send({
      url: this.actionUrl + "/revoke",
      method: "POST"
    }, handlers);
  }


  public sendAdditional(handlers: IHandlers) {
    this.send({
      url: this.actionUrl + "/additional",
      method: "POST"
    }, handlers);
  }

  public sendPDF(handlers: IHandlers) {
    this.send({
      url: this.actionUrl + "/pdf",
      method: "POST"
    }, handlers);
  }

  public cloneRequest(handlers: IHandlers) {
    this.send({
      url: `${this.actionUrl}/clone`,
      method: "POST"
    }, handlers);
  }

  public deleteValues(handlers: IHandlers) {
    this.send({
      url: this.actionUrl + "/delete",
      method: "DELETE",
    }, handlers);
  }

  public getFileUrl(controlId: string, fileName: string, timestamp ? : number): string {
    if (timestamp !== undefined)
      fileName = timestamp + "/" + fileName;

    console.log('OPTIONS', this.options, `${this.options.apiUrl}/${this.options.process_id}/${controlId}/${fileName}`);

    return encodeURI(`${this.options.apiUrl}/${this.options.process_id}/${controlId}/${fileName}`);
  }

  public setValue(id: string, value: any, handlers: IHandlers = null) {
    handlers.error = errorHandler;

    this.send({
      url: this.setValueUrl + id,
      method: "POST",
      contentType: "application/json; charset=utf-8",
      data: JSON.stringify({
        timestamp: Date.now(),
        value: typeof value === 'object' ? JSON.stringify(value) : value
      })
    }, handlers);
  }

  public setValueSync(id: string, value: any, handlers: IHandlers = null) {

    this.send({
      url: this.setValueUrl + "/" + id,
      method: "POST",
      contentType: "application/json; charset=utf-8",
      data: JSON.stringify({
        timestamp: Date.now(),
        value
      })
    }, handlers, false);
  }

  public putValue(id: string, value: any, handlers: IHandlers = null): number {
    const timestamp = Date.now();

    this.send({
      url: this.setValueUrl + "/" + id,
      method: "PUT",
      contentType: "application/json",
      data: JSON.stringify({
        timestamp: timestamp,
        value: value
      })
    }, handlers);
    return timestamp;
  }

  public removeValue(id: string, timestamp: number, handlers: IHandlers = null) {
    handlers.error = errorHandler;
    this.send({
      url: this.setValueUrl + id, /* + "/?timestamp=" + timestamp, */
      method: "DELETE"
    }, handlers);
  }

  public removeReportPdf(formId: string, values: string, handlers: IHandlers = null) {
    this.send({
      url: `${this.options.apiUrl}/${formId}/${values}/report`,
      method: "DELETE"
    }, handlers);
  }

  public setFileValue(options: IFileOptions, value: any, fileId: string, handlers: IHandlers): string {
    const file = options.element.files[0];
    if (file == undefined || file == null)
      return null;

    const data = new FormData();
    data.append("file", file);
    data.append("value", value);
    data.append("fileId", fileId);

    let success: IHandler = null;
    if (handlers != null && handlers.success != null) {
      success = handlers.success;
      handlers.success = function (res) {
        success(res);
      }
      handlers.error = errorHandler;
    }

    this.send({
      xhr: function (): XMLHttpRequest {
        const xhr = new XMLHttpRequest();
        if (handlers != null && handlers.progress != null) {
          xhr.upload.addEventListener("progress", e => {
            handlers.progress(e.loaded / e.total * 100)
          });
        }
        return xhr;
      },
      url: this.filesUrl + options.id + "/file/" + options.field,
      method: "POST",
      contentType: false,
      data: data,
      processData: false
    }, handlers);
  }

  public deleteFileValue(id: string, fileName: string, value: any, fileId: string, handlers: IHandlers) {
    handlers.error = errorHandler;
    this.send({
      url: encodeURI(this.filesUrl + id + "/file/" + fileId,),
      method: "DELETE"
    }, handlers);
  }

  public getFormByUid(id: string, values: number, handlers: IHandlers) {
    getJSON(`${this.urlApi}/${id}/${values}`, handlers.success)
      .fail(handlers.error);
  }

  public getAllValues(handlers: IHandlers) {
    getJSON(this.urlApi, handlers.success)
      .fail(handlers.error);
  }

  public getForms(handlers: IHandlers) {
    getJSON(`${this.urlApi}/all/`, handlers.success).always(handlers.anyway);
  }

  public createForm(data: object, handlers: IHandlers) {
    this.send({
      url: `${this.urlApi}/item/create/`,
      method: "POST",
      contentType: "application/json",
      data: JSON.stringify(data)
    }, handlers);
  }

  public copyForm(form_type:string, process_id: number, handlers: IHandlers) {
    this.send({
      url: `${this.urlApi}/item/clone/${form_type}/${process_id}`,
      method: "POST"
    }, handlers);
  }

  public revokeForm(form_type:string, process_id: number, handlers: IHandlers) {
    this.send({
      url: `${this.urlApi}/item/revoke/${form_type}/${process_id}`,
      method: "POST"
    }, handlers);
  }

  public deleteForm(form_type:string, process_id: number, handlers: IHandlers) {
    this.send({
      url: `${this.urlApi}/item/${form_type}/${process_id}`,
      method: "DELETE"
    }, handlers);
  }

  /* Example JSON connect */
  public openForm(handlers: IHandlers) {
    Promise.all([
      new Promise(() => {
        handlers.anyway();
        return handlers.success(MetaJSON);
      })
    ]);
  }

  public companyInfo(inn: string, handlers: IHandlers) {
    getJSON(`${this.userApi}/company/${inn}`, handlers.success)
      .fail(handlers.error);
  }

  public suggest(text: string, handlers: IHandlers) {
    this.send({
      url: `${this.userApi}/suggest`,
      method: "POST",
      contentType: "application/json",
      data: JSON.stringify({
        query: text
      })
    }, handlers);
  }

  public getValue(controlId: string, handlers: IHandlers) {
    this.send({
      url: this.setValueUrl + "/" + controlId,
      method: "GET",
    }, handlers)
  }

  public isRemovePanelBlock(key: string, handlers: IHandlers) {
    this.send({
      url: `${this.setValueUrl}/${key}/isremove`,
      method: "GET"
    }, handlers)
  }

  public hasRemoveBlock(key: string, handlers: IHandlers) {
    this.send({
      url: `${this.setValueUrl}/${key}/hasremove`,
      method: "GET"
    }, handlers)
  }

  private send(options: RequestOptions, handlers: IHandlers, async :boolean = true) {
    let success: IHandler = null;
    let error: IErrorHandler = null;
    let anyway: IHandler = null;
    if (handlers) {
      success = handlers.success;
      error = handlers.error;
      anyway = handlers.anyway;
    }

    ajax({
      xhr: options.xhr,
      url: options.url,
      type: options.method,
      contentType: options.contentType,
      data: options.data,
      processData: options.processData,
      crossDomain: true,
      success: success,
      complete: anyway,
      async,
      error: function (jqXHR: JQueryXHR) {
        if (error != null)
          error(jqXHR.status, jqXHR.responseText);
      },
    });
  }

  private static getFileExtension(fileName: string) {
    return fileName.substring(fileName.lastIndexOf(".") + 1).toUpperCase();
  }
}
